import { BiChevronRight, BiPencil, BiPlus } from "react-icons/bi";
import { Button } from "../../../pages/helpCenter";
import { BsArrowLeft, BsTrash2 } from "react-icons/bs";

export const SubcategoryDetail = ({ subcategory, category, articles, onEdit, onDelete, onAddArticle, onOpenArticle, onBackToCategory }) => {
  return (
    <div className="mx-auto max-w-3xl px-6 py-8 sm:px-10">
      <button type="button" onClick={onBackToCategory} className="mb-4 inline-flex items-center gap-1 text-xs font-medium text-slate-400 hover:text-slate-700">
        <BsArrowLeft size={13} /> {category?.name}
      </button>
      <div className="mb-6 flex items-start justify-between gap-4">
        <div>
          <div className="mb-2 flex items-center gap-2">
            <span className="h-2.5 w-2.5 rounded-full"/>
            <span className="text-xs font-semibold uppercase tracking-wide text-slate-400">Subcategory</span>
          </div>
          <h1 className="font-serif text-2xl font-bold text-slate-900">{subcategory.name}</h1>
          {subcategory.description && <p className="mt-2 text-sm text-slate-500">{subcategory.description}</p>}
        </div>
        <div className="flex shrink-0 gap-2">
          <Button variant="secondary" size="sm" onClick={onEdit}>
            <BiPencil size={14} /> Edit
          </Button>
          <Button variant="dangerGhost" size="sm" onClick={onDelete}>
            <BsTrash2 size={14} /> Delete
          </Button>
        </div>
      </div>

      <div className="mb-8 grid grid-cols-2 sm:w-64">
        <div className="rounded-lg border border-slate-200 bg-white px-3 py-2">
          <p className="text-xs text-slate-400">Articles</p>
          <p className="text-lg font-semibold">
            {articles.length}
          </p>
        </div>
      </div>

      <div>
        <div className="mb-3 flex items-center justify-between">
          <h3 className="text-sm font-semibold text-slate-900">Articles</h3>
          <Button variant="ghost" size="sm" onClick={onAddArticle}>
            <BiPlus size={14} /> Add article
          </Button>
        </div>
        {articles.length === 0 ? (
          <p className="rounded-lg border border-dashed border-slate-300 px-4 py-6 text-center text-sm text-slate-400">
            No articles yet.
          </p>
        ) : (
          <div className="space-y-2">
            {articles.map((a) => (
              <button
                key={a.id}
                type="button"
                onClick={() => onOpenArticle(a)}
                className="flex w-full items-center justify-between gap-3 rounded-xl border border-slate-200 bg-white p-4 text-left transition-shadow hover:shadow-md"
              >
                <div className="min-w-0">
                  <p className="truncate font-medium text-slate-800">{a.title}</p>
                  {a.description && <p className="mt-0.5 truncate text-xs text-slate-500">{a.description}</p>}
                </div>
                <BiChevronRight size={16} className="shrink-0 text-slate-300" />
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}